/* eslint-disable react/prop-types */
import { Table as AntdTable } from 'antd';
import cn from 'clsx';
import React from 'react';
import classes from './Table.module.scss';

const ATable = ({
  className = '',
  box,
  standardPagination,
  pagination,
  newStyle,
  rowIsClick,
  hidePagination,
  ...other
}) => {
  return (
    <AntdTable
      {...other}
      className={cn(
        classes.wrapper,
        {
          [classes.box]: box,
          [classes.newStyle]: newStyle,
          [classes.rowIsClick]: rowIsClick,
        },
        className
      )}
      pagination={
        hidePagination
          ? false
          : {
              ...(standardPagination
                ? {
                    showSizeChanger: true,
                    pageSize: 10,
                    showTotal: (total, range) => {
                      return `${range[0]}-${range[1]} of ${total}`;
                    },
                  }
                : {}),
              ...(pagination || {}),
            }
      }
    />
  );
};

export default ATable;
